import React from 'react'

import IcaewModalSteps from '@/components/modals/IcaewModals/components/IcaewModalSteps'
import { useIcaewModals } from '@/components/modals/IcaewModals/hooks/useIcaewModals'
import { DialogHeader, DialogTitle } from '@/components/ui/dialog'

interface Props {
  children: React.ReactNode
}

const IcaewModalHeader: React.FC<Props> = ({ children }) => {
  const { shouldShowStepIndicators } = useIcaewModals()

  return (
    <DialogHeader>
      <DialogTitle>
        {children}
        {shouldShowStepIndicators && <IcaewModalSteps />}
      </DialogTitle>
    </DialogHeader>
  )
}

export default IcaewModalHeader
